<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { BIcon, BIconGearFill, BIconEnvelopeFill, BIconPhoneFill, BIconKeyFill } from 'bootstrap-vue'
import { twoFactorAuthMethods, usersMethods } from '@state/helpers'
import { required, minLength, sameAs, helpers } from 'vuelidate/lib/validators'
import getSecret from '@/src/utils/get-secret'

const passwordStrength = helpers.regex('passwordStrength', /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/)

export default {
  page: {
    title: 'Security',
    meta: [{ name: 'Security', content: 'Security' }],
  },
  components: { 
    Layout, 
    PageHeader,
    BIcon,
    BIconGearFill,
    BIconEnvelopeFill, 
    BIconPhoneFill,
    BIconKeyFill
  },
  data() {
    return {
      title: 'Security',
      breadcrumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Security',
          active: true,
        },
      ],
      secretQR: '',
      qrXML: '',
      codeToVerify: '',
      isQRModalOpen: false,
      isEmailModalOpen: false,
      isCancelTotpModalOpen: false,
      isCancelEmailModalOpen: false,
      isTotpAuthEnabled: false,
      isEmailAuthEnabled: false,
      updatePwForm: {
        currentPassword: '',
        password: '',
        repeat_password: ''
      },
      isPasswordModalOpen: false,
      isSendingPassword: false,
      isChangePassError: false,
      isGettingAuthDevices: false,
      isGettingQRCode: false,
      isVerifying: false,
      isSubmitting: false,
      a2f_enabled: getSecret('A2F_ENABLED'),
    }
  },
  validations: {
    updatePwForm: {
      currentPassword: {
        required
      },
      password: {
        required,
        minLength: minLength(6),
        passwordStrength,
      },
      repeat_password: {
        required,
        sameAsPassword: sameAs('password')
      },
    },
  },
  async mounted() {
    this.getUserAuthDevices();
  },
  methods: {
    ...twoFactorAuthMethods,
    ...usersMethods,

    async getUserAuthDevices() {
      this.isGettingAuthDevices = true; 
      try {
        const authDevices = await this.fetchAuthDevices();
        this.isEmailAuthEnabled = authDevices.filter(
        (value) => value.type == 'email').length ? true : false;
        this.isTotpAuthEnabled = authDevices.filter(
          (value) => value.type == 'totp').length ? true : false;
        this.isGettingAuthDevices = false;
      } catch (error) {
        console.log(error.response)
      }
    },

    async getQrCode(){
      if(this.qrXML) {
        return
      }
      this.isGettingQRCode = true;
      try {
        ({ secret: this.secretQR, qr_code: this.qrXML } = await this.fetchQR());
        // console.log('secret', this.secretQR);
        this.isGettingQRCode = false;
      } catch (error) {
        console.log(error.response)
      }
    },

    async verifyCode() {
      console.log('verifying...');
      this.isVerifying = true;
      const { error, isValid } = await this.activateTotpAuth(this.codeToVerify);

      if(error) {
        const errorResponse = error.response || {};
        if(errorResponse.status === 400) {
          this.$generate_toast(this, 'error',
            this.$t('a2f_section.token_expired_or_invalid'));
        } else if (errorResponse.status === 404) {
          this.$generate_toast(this, 'error',
            this.$t('a2f_section.failed_to_enable_two_factor_auth'));
        } else {
          this.$axios_error_noty(error, this);
        }
        this.codeToVerify = ''
        this.isVerifying = false;
        return;
      }

      this.isVerifying = false;
      this.$generate_toast(
        this, 'success', this.$t('a2f_section.two_factor_auth_enabled'));
      this.isQRModalOpen = false;
      this.isTotpAuthEnabled = true;
      this.codeToVerify = '';
      this.qrXML = '';
      this.secretQR = '';
    },
    
    async enableEmailVerification() {
      this.isSubmitting = true;
      try {
        await this.activateEmailAuth();
        this.$generate_toast(this, 'success',
        this.$t('a2f_section.two_factor_auth_enabled'));
        this.isEmailAuthEnabled = true;
      } catch (error) {
        this.$generate_toast(this, 'error',
        this.$t('a2f_section.failed_to_enable_two_factor_auth'));
      }
      this.isSubmitting = false;
      this.isEmailModalOpen = false;
    },

    async disableTotpVerification() {
      this.isSubmitting = true;
      try {
        await this.deleteTotpAuth();
        this.$generate_toast(this, 'success',
          this.$t('a2f_section.two_factor_auth_disabled'));
        this.isTotpAuthEnabled = false;
      } catch (error) {
        this.$generate_toast(this, 'success',
          this.$t('a2f_section.failed_to_disable_two_factor_auth'));
      }
      this.isSubmitting = false;
      this.isCancelTotpModalOpen = false;
    },

    async disableEmailVerification() {
      this.isSubmitting = true;
      try {
        await this.deleteEmailAuth();
        this.$generate_toast(this, 'success',
          this.$t('a2f_section.two_factor_auth_disabled'));
        this.isEmailAuthEnabled = false;
      } catch (error) {
        this.$generate_toast(this, 'success',
          this.$t('a2f_section.failed_to_disable_two_factor_auth'));
      }
      this.isSubmitting = false;
      this.isCancelEmailModalOpen = false;
    },

    copyKey(){
      navigator.clipboard.writeText(this.secretQR)
    },

    async setPassword() {
      console.log('aqui')
      this.isSendingPassword = true;
      try {
        const url = this.$store.state.auth.currentSession.user.url;
        console.log('aqui2')
        await this.changePassword({ 
          url, 
          current_password: this.updatePwForm.currentPassword,
          password: this.updatePwForm.password
         });
      } catch (error) {
        this.isSendingPassword = false;
        if(error.response.status === 403) {
          this.isChangePassError = true;
          return;
        }
        this.$axios_error_noty(error, this)
        return;
      }
      this.isPasswordModalOpen = false;
      this.isSendingPassword = false;
      this.$generate_toast(this, 'success', this.$t('login_section.password_changed_successfully'));
    },
    
    onHiddenPasswordModal() {
      this.updatePwForm.currentPassword = '';
      this.updatePwForm.password = '';
      this.updatePwForm.repeat_password = '';
      this.isChangePassError = false;
    }
  },
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="breadcrumbs"
    />

    <div class="row">
      <div class="col-md-6">
        <b-card :header="$t('password')">
          <b-card-text>
            <!-- enable TOTP auth button -->
            <b-button variant="primary" v-b-modal.modal-password class="mr-2 mb-2" block
            >
              <b-icon icon="key-fill" aria-hidden="true"></b-icon> 
              {{ $t('login_section.change_password') }}
            </b-button>
          </b-card-text>
        </b-card>

        <b-card v-if="a2f_enabled" :header="$t('securitySection.two_Factor_authentication')">
          <b-card-text>
            <div class="row justify-content-center">
              <b-spinner
                v-if="isGettingAuthDevices"
                label="Spinning"
                variant="secondary"
                class="mb-2"
              >
              </b-spinner>
            </div>

            <!-- enable TOTP auth button -->
            <b-button variant="secondary" v-b-modal.modal-qr class="mr-2 mb-2" block v-show="!isTotpAuthEnabled"
            >
              <b-icon icon="phone-fill" aria-hidden="true"></b-icon> 
              {{ $t('securitySection.enable_authenticator_app') }}
            </b-button>
            <!-- disable TOTP auth button -->
            <b-button variant="warning" v-b-modal.modal-disable-totp class="mr-2 mb-2" block v-show="isTotpAuthEnabled"
            >
              <b-icon icon="phone-fill" aria-hidden="true"></b-icon> 
              {{ $t('securitySection.disable_authenticator_app') }}
            </b-button>
            <!-- enable Email auth button -->
            <b-button variant="secondary" v-b-modal.modal-email class="mr-2 mb-2" block v-show="!isEmailAuthEnabled"
            >
              <b-icon icon="envelope-fill" aria-hidden="true"></b-icon> 
              {{ $t('securitySection.enable_email_verification') }}
            </b-button>
            <!-- disable Email auth button -->
            <b-button variant="warning" v-b-modal.modal-disable-email class="mr-2 mb-2" block v-show="isEmailAuthEnabled"
            >
              <b-icon icon="envelope-fill" aria-hidden="true"></b-icon> 
              {{ $t('securitySection.disable_email_verification') }}
            </b-button>
          </b-card-text>
        </b-card>

        <!-- Modal to generate QR Code -->
        <b-modal id="modal-qr" centered :title="$t('securitySection.authenticator_app')"
          @show="getQrCode" @ok.prevent="verifyCode" v-model="isQRModalOpen"
          :ok-disabled="codeToVerify.length<6 || isVerifying"
          @hidden="() => { codeToVerify='' }"
        >
          <div class="text-center">
            <p class="my-1">{{ $t('securitySection.scan_the_code') }}</p>
            <div class="row justify-content-center">
              <b-spinner
                v-if="isGettingQRCode"
                label="Spinning"
                variant="secondary"
                class="my-2"
              >
              </b-spinner>
            </div>
            <div v-html="qrXML" class="my-2"></div>
            <div class="row mx-3 my-3">
              <b-input readonly v-model="secretQR" class="col-10"></b-input>
              <b-button class="col-2 bg-primary" @click="copyKey">Copy</b-button>
            </div>
            <p class="my-1">{{ $t('securitySection.enter_the_code') }}</p>
            <b-form @submit.prevent="tryToVerifyToken" class="row mx-3 my-3 justify-content-center">
              <b-form-input v-model="codeToVerify" class="col-5" type="number" 
                required min="0">
              </b-form-input>
            </b-form>
          </div>

          <template v-slot:modal-ok>
            <span
              v-if="!isVerifying"
            >
              {{ $t('basic.verify') }}
            </span>
            <b-spinner
              v-if="isVerifying"
              small
              label="Spinning"
              variant="light"
            >
            </b-spinner>
          </template>

          <template v-slot:modal-cancel>
            <span> {{ $t('basic.cancel') }} </span>
          </template>
        </b-modal>

        <!-- Modal to enable email auth -->
        <b-modal id="modal-email" centered :title="$t('securitySection.email_authentication')"
          @ok.prevent="enableEmailVerification" v-model="isEmailModalOpen"
          cancel-title="No"
          @hidden="() => { isSubmitting=false }"
          :ok-disabled="isSubmitting"
        >
          <p class="text-center h5">
            {{ $t('securitySection.want_to_enable_email_authentication') }}
          </p>
          <template v-slot:modal-ok>
            <span
              v-if="!isSubmitting"
            >
              {{ $t('basic.yes') }}
            </span>
            <b-spinner
              v-if="isSubmitting"
              small
              label="Spinning"
              variant="light"
            >
            </b-spinner>
          </template>
        </b-modal>

        <!-- Modal to disable totp auth -->
        <b-modal id="modal-disable-totp" centered :title="$t('securitySection.disable_authenticator_app')"
          @ok.prevent="disableTotpVerification" v-model="isCancelTotpModalOpen"
          cancel-title="No"
          @hidden="() => { isSubmitting=false }"
          :ok-disabled="isSubmitting"
        >
          <p class="text-center h5">
            {{ $t('securitySection.want_to_disable_authenticator_app') }}
          </p>
          <template v-slot:modal-ok>
            <span
              v-if="!isSubmitting"
            >
              {{ $t('basic.yes') }}
            </span>
            <b-spinner
              v-if="isSubmitting"
              small
              label="Spinning"
              variant="light"
            >
            </b-spinner>
          </template>
        </b-modal>

        <!-- Modal to disable email auth -->
        <b-modal id="modal-disable-email" centered :title="$t('securitySection.disable_email_verification')"
          @ok.prevent="disableEmailVerification" v-model="isCancelEmailModalOpen"
          cancel-title="No"
          @hidden="() => { isSubmitting=false }"
          :ok-disabled="isSubmitting"
        >
          <p class="text-center h5">
            {{ $t('securitySection.want_to_disable_email_authentication') }}
          </p>
          <template v-slot:modal-ok>
            <span
              v-if="!isSubmitting"
            >
              {{ $t('basic.yes') }}
            </span>
            <b-spinner
              v-if="isSubmitting"
              small
              label="Spinning"
              variant="light"
            >
            </b-spinner>
          </template>
        </b-modal>
      </div>
    </div>

    <!-- Modal to change password -->
    <b-modal id="modal-password" centered :title="$t('login_section.change_password')"
      ok-title="Yes" cancel-title="No"
      @ok.prevent="setPassword" v-model="isPasswordModalOpen"
      @hidden="onHiddenPasswordModal"
    >
      <b-alert v-model="isChangePassError" variant="danger" dismissible>
        {{ $t('securitySection.your_current_password_is_not_correct') }}
      </b-alert>

      <b-form>
        <form-wrapper :validator="$v.updatePwForm ">
          <form-group name="password" :label="$t('securitySection.current_password')">
            <b-form-input
              v-model="updatePwForm.currentPassword"
              type="password"
            /> 
            <div class="text-warning" v-if="!$v.updatePwForm.currentPassword.required">
              *{{ $t('validation.requiredField') }}
            </div>  
          </form-group>

          <form-group name="password" :label="$t('securitySection.new_password')">
            <b-form-input
              v-model="updatePwForm.password"
              type="password"
            /> 
            <div class="text-warning mb-1">
              <div v-if="!$v.updatePwForm.password.minLength">
                *{{ $t('validation.minPasswordLength', { minLength: $v.updatePwForm.password.$params.minLength.min }) }}
              </div>
              <div v-if="!$v.updatePwForm.password.passwordStrength">
                *{{ $t('validation.passwordStrength') }}
              </div>
            </div>
          </form-group>
          
          <form-group name="repeat_password" :label="$t('securitySection.repeat_new_password')">
            <b-form-input
              v-model="updatePwForm.repeat_password"
              type="password"
            /> 
            <div class="text-warning" v-if="!$v.updatePwForm.repeat_password.sameAsPassword">
              *{{ $t('validation.sameAsPassword') }}
            </div>   
          </form-group>       
        </form-wrapper>
      </b-form>

      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="isPasswordModalOpen = false"
        >
          {{ $t('basic.cancel') }}
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="setPassword"
          :disabled="$v.updatePwForm.$invalid || isSendingPassword"
        >
          <span
            v-if="!isSendingPassword"
          >
            {{ $t('submit') }}
          </span>
          <b-spinner
            v-if="isSendingPassword"
            small
            label="Spinning"
            variant="light"
          >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

  </Layout>
</template>
